/**
 * Handle scaling and poster image event listeners for 3rd party iframe video embeds
 * @param   {object} videoInstance The iframe DOM element for the video
 * @returns {undefined}            Returns nothing
 */
export function handleThirdPartyVideoEmbed(videoInstance) {
    const videoContainer = '.js-external-video';
    const instance = videoInstance;
    const $videoInstance = $(videoInstance);
    const $poster = $videoInstance.parent().parent().children('.js-external-video-poster');

    if ($poster.length > 0) {
        // bind event to the poster image swap iframe src, set video size, and hide the poster
        $poster.on('click', (e) => {
            const posterHeight = $poster.height();

            $(e.target).css('display', 'none');
            $videoInstance.attr('data-src', $videoInstance.attr('src')).removeAttr('src');

            const dataSrc = $videoInstance.attr('data-src');
            const autoplaySource = dataSrc.includes('?') ? `${dataSrc}&autoplay=1` : `${dataSrc}?autoplay=1`;
            $videoInstance.attr('allow', 'autoplay');
            $videoInstance.attr('src', autoplaySource).parent().addClass('is-visible');

            // Set up aspect ration and video source
            $videoInstance.attr('data-aspect-ratio', instance.height / instance.width).removeAttr('height').removeAttr('width');

            // Figure out new width and height based on aspect ratio and parent/poster image
            const aspectRatio = $videoInstance.attr('data-aspect-ratio');
            const fillWidth = $videoInstance.parents(videoContainer).width();
            const fillHeight = fillWidth * aspectRatio;
            const containHeight = posterHeight;

            if (posterHeight < fillHeight) {
                // don't let video take up more vertical space than its
                // placeholder image, otherwise it breaks the layout
                $videoInstance.width(fillWidth).height(containHeight);
            } else {
                $videoInstance.width(fillWidth).height(fillHeight);
            }
        });
    } else {
        // Set up aspect ratio and video source
        $videoInstance.attr('data-aspect-ratio', instance.height / instance.width).removeAttr('height').removeAttr('width');

        // Define new width and height based on aspect ratio
        const newWidth = $videoInstance.parents(videoContainer).width();
        const newHeight = newWidth * $videoInstance.attr('data-aspect-ratio');

        $videoInstance.width(newWidth).height(newHeight);
    }
}
